import React, { ReactElement } from 'react';
import MenuInterface, { MenuKeys } from 'modules/shared/layout/menu/interfaces/menu.interface';

import './recommended.scss';

interface RecommendedInterface {
    recommendedItems: MenuInterface[MenuKeys.recommended];
}

const Recommended: React.FC<RecommendedInterface> = ({ recommendedItems }): ReactElement | null => {
    if (!recommendedItems?.length) {
        return null;
    }

    return (
        <div className="recommended" data-section="recommended">
            <div className="recommended__header">
                Popularni producenci
            </div>
            <ul className="recommended__list row">
                {recommendedItems.map(item => (
                    <li className="recommended__list__item col col-6" key={item.url}>
                        <a href={item.url} title={item.title} target={item.target}>
                            <img src={item.image} alt={item.title} />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Recommended;
